// src/components/ServersParser/ServersParserSearchCapsule.jsx
import React, { useRef } from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

const ServersParserSearchCapsule = ({ value, onChange }) => {
  const { language } = useLanguage();
  const isEn = language === 'en';
  const inputRef = useRef(null);

  const handleClear = () => {
    onChange('');
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  return (
    <div className="sp-search-input-capsule">
      <div className="sp-search-icon-badge">
        <svg viewBox="0 0 24 24" fill="none">
          <circle cx="11" cy="11" r="8" />
          <line x1="21" y1="21" x2="16.65" y2="16.65" />
        </svg>
      </div>

      <input
        ref={inputRef}
        type="text"
        className="sp-search-text-field"
        placeholder={isEn ? 'Search parsed servers...' : 'Поиск по спарсенным серверам...'}
        autoComplete="off"
        spellCheck="false"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />

      {value && (
        <button
          type="button"
          className="sp-search-clear-btn"
          onClick={handleClear}
          title={isEn ? 'Clear search' : 'Очистить поиск'}
        >
          <svg viewBox="0 0 24 24" fill="none">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      )}
    </div>
  );
};

export default ServersParserSearchCapsule;
